import React, { useState, useEffect, useContext }  from 'react'
import { APIRequestContext } from '../wrappers/APIRequestContext'
import withConfig from '../wrappers/withConfig'
import DetailsLink from './DetailsLink'
import toast from './Toast'
import ReactTooltip from "react-tooltip"
import { useNavigate } from "react-router-dom";
import urls from '../../utils/constants/urls';

const StateList = ({ config, onSelected }) => {

    const [ result, setResult ] = useState([])
    const [ authenticatedFetch, env ] = useContext(APIRequestContext)
    const { API_URL } = config
    const navigate = useNavigate();
    
    useEffect(() => {
        loadStates()
    }, [env]);

    useEffect(() => {
        ReactTooltip.rebuild();
    });

    const loadStates = () => {
        setResult('loading')
        authenticatedFetch(`${API_URL}?method=getStates2`, {
            crossDomain: true })
            .then(async (response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    const error = await response.text()
                    throw new Error(error)
                }
            })
            .then((response) => {
                setResult(response)
            })
            .catch((e) => {
                toast({
                    level: 'error',
                    message:
                        'Landing Page:' +
                        (e.message
                            ? e.message
                            : 'Unable to connect to the server'),
                })
            })
            .finally(
                
            )
    }

    const handleClick = (state) => {
        onSelected(state)
    }

    const showState = (state) => {
        // set bounds in [sw, ne]
        let bounds = [
            [state.CENTER[0] - state.LONGDELTA / 2, state.CENTER[1] - state.LATDELTA / 2],
            [state.CENTER[0] + state.LONGDELTA / 2, state.CENTER[1] + state.LATDELTA / 2]]


        window.sessionStorage.setItem('bounds', JSON.stringify(bounds))
        window.sessionStorage.setItem('latitude', 39.8283)
        window.sessionStorage.setItem('longitude', -98.5795)
        window.sessionStorage.setItem('zoom', 3.5)

        navigate(urls.map)
    }

    if (result === 'loading') {
        return (<h2>Loading ...</h2>)
    }

    if (!result || result.SUCCESS === undefined) {
        return null
    }

    if (result.SUCCESS !== true) {
        return (
            <h2>{result.MESSAGE}</h2>
        )
    }

    return (
        <>
            <ReactTooltip id="tooltip-info" place="right" type="dark" effect="float" />
            <table>
                <tbody>
                    <tr className="search-header">
                        <td colSpan={4}>States</td>   
                    </tr>
                    {result.ADATA
                    .sort((a, b) => a.NAME > b.NAME ? 1 : -1)
                    .map((item, i) => (
                        <tr key={i}>
                            <td className="search-img"><a data-for="tooltip-info" data-tip="Show on Map" onClick={() => showState(item)}><img src="/images/map-marker-alt.png" /></a></td>
                            <td className="search-data"><span>{item.NAME}</span></td>
                            <td className="search-wellcount"><span>{item.WELLCOUNT}</span></td>
                            <td className="nav-next"><DetailsLink value={item.ABBR} handleClick={handleClick} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default withConfig(StateList)